import $ from 'jquery';
import { renderQuantity } from './conversion';
export { renderIngredientHTML };
function renderIngredientHTML(ingredient) {
    var _a, _b;
    const xml = $.parseXML(`<xml>${ingredient.markup}</xml>`).firstChild;
    const container = $('<div />');
    const quantity = renderQuantity(ingredient.quantity);
    const quantityHTML = `${(_a = quantity.magnitude) !== null && _a !== void 0 ? _a : ''} ${(_b = quantity.units) !== null && _b !== void 0 ? _b : ''}`.trim();
    container.append($('<div />', { 'class': 'quantity', 'html': quantityHTML }));
    $(xml.childNodes).remove('amt');
    $(xml).find('ingredient').replaceWith((idx, text) => $('<span />', { 'class': 'product', 'text': text }).addClass(ingredient.product.state));
    container.append($('<div />', { 'class': 'ingredient', 'html': xml.childNodes }));
    return container.html();
}
